if (!customElements.get('ingredients-carousel')) {
  customElements.define(
    'ingredients-carousel',
    class IngredientsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ingredients__track');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        if (!this.track) return;

        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = (parseInt(this.dataset.speed, 10) || 4) * 1000;
        this.timer = null;

        this.prevBtn && this.prevBtn.addEventListener('click', () => this.onManual(-1));
        this.nextBtn && this.nextBtn.addEventListener('click', () => this.onManual(1));
        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        window.addEventListener('resize', () => this.updateArrows());
        this.updateArrows();

        // Pausar autoplay al interactuar
        ['mouseenter', 'touchstart', 'focusin'].forEach((ev) =>
          this.addEventListener(ev, () => this.stop(), { passive: true })
        );
        ['mouseleave', 'touchend', 'focusout'].forEach((ev) =>
          this.addEventListener(ev, () => this.start(), { passive: true })
        );

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const inEditor = window.Shopify && window.Shopify.designMode;
        if (this.autoplay && !reduceMotion && !inEditor) this.start();
      }

      cardStep() {
        const card = this.track.querySelector('.ingredient-card');
        if (!card) return this.track.clientWidth * 0.8;
        const style = getComputedStyle(this.track);
        const gap = parseFloat(style.columnGap || style.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      isOverflowing() {
        return this.track.scrollWidth > this.track.clientWidth + 4;
      }

      atEnd() {
        return this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 4;
      }

      advance() {
        if (!this.isOverflowing()) return;
        if (this.atEnd()) {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.track.scrollBy({ left: this.cardStep(), behavior: 'smooth' });
        }
      }

      scrollByCards(dir) {
        this.track.scrollBy({ left: dir * this.cardStep(), behavior: 'smooth' });
      }

      onManual(dir) {
        this.scrollByCards(dir);
        this.restart();
      }

      start() {
        if (!this.autoplay || !this.isOverflowing()) return;
        this.stop();
        this.timer = setInterval(() => this.advance(), this.interval);
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      restart() {
        this.stop();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const inEditor = window.Shopify && window.Shopify.designMode;
        if (this.autoplay && !reduceMotion && !inEditor) this.start();
      }

      updateArrows() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        const x = this.track.scrollLeft;
        const overflowing = this.isOverflowing();
        if (this.prevBtn) this.prevBtn.toggleAttribute('hidden', !overflowing || x <= 2);
        if (this.nextBtn) this.nextBtn.toggleAttribute('hidden', !overflowing || x >= max);
      }

      disconnectedCallback() {
        this.stop();
      }
    }
  );
}
